import React from 'react';
import { Route, Switch } from 'react-router';
import { BaseLayout } from './containers/Layout';
import DirectReports from './containers/DirectReports';
import UserPreferences from './containers/UserPreferences';
import NotFound from './components/NotFound';
import { Routes } from './shared/constants';
import { Card } from 'antd';
import { msalInstance } from './config/azureAd';
import { fadeIn } from './shared';
import styled from 'styled-components';
import { Redirect } from 'react-router-dom';
import LrsHome from './containers/Home/LrsHome.jsx';
import GprsHome from './containers/Home/GprsHome.jsx';
import EngineeringHome from './containers/Home/EngineeringHome.jsx';
import PropTypes from 'prop-types';
import NotificationModal from './components/NotificationModal';

const Empty = () => (<Card></Card>);
const StyledCard = styled(Card)`
  animation: ${fadeIn} .4s both ease-in-out;
`;
const InvalidUser = () => {
  return (
    <StyledCard>
      <div data-test="grid-display">
        <p>ACCESS DENIED</p>
        <p>You do not have permission to access this page.</p>
        <p>Please confirm with your manager if you need access and then log a ticket for access.</p>
      </div>
    </StyledCard>
  );
};

const AppRoute = ({ component: Component, layout: Layout, rights, ...rest }) => {
  return (
    <Route {...rest} render={props => {
      const account = msalInstance.getActiveAccount();
      if (!account) {
        // redirect anonymous user to login page
        msalInstance.loginRedirect();
      }
      const roles = account?.idTokenClaims?.roles;
      if (roles && roles.some(r => ['User', 'SuperUser', 'Admin'].includes(r))) {
        return (
          <Component {...props} />
        );
      } else {
        return <Redirect to={{ pathname: '/Invalid' }} />;
      }
    }} />
  );
};

const App = () => (
    <BaseLayout>
    <NotificationModal />
      <Switch>
        <AppRoute path={Routes.LRS} component={LrsHome} />
        <AppRoute path={Routes.GPRS} component={GprsHome} />
        <AppRoute path={Routes.VPIN} component={EngineeringHome} />
        <AppRoute path={Routes.PREFERENCES} component={UserPreferences} />
        <AppRoute path={Routes.DIRECTREPORTS} component={DirectReports} />
        <Route exact path={'/Invalid'} component={InvalidUser} />
        <Route exact path={'/'} component={Empty} />
        <Route exact component={NotFound} />
      </Switch>
    </BaseLayout>
);

AppRoute.propTypes = {
  component: PropTypes.elementType.isRequired,
  layout: PropTypes.elementType,
  rights: PropTypes.arrayOf(PropTypes.string),
};

export default App;
